export enum RecipePartsEnum {
    'ingredients' = 'INGREDIENTS',
    'instructions' = 'INSTRUCTIONS',
}

export interface Recipe {
    _id: string;
    name: string;
    img: {
        landscape: {
            url: string;
        }
    };
    image: string;
    imgName: string;
    portraitImgName: string;
    ingredients: string;
    instructions: string;
    preparation: any;
    title: string;
};
